// custom-paginator-intl.ts
import { MatPaginatorIntl } from '@angular/material/paginator';
import { Injectable } from '@angular/core';

@Injectable()
export class CustomMatPaginatorIntl extends MatPaginatorIntl {
  itemsPerPageLabel = 'Artículos por página';

     // Cambia el texto "de" por otro texto de tu elección
  getRangeLabel = (page: number, pageSize: number, length: number) => {
    if (length === 0 || pageSize === 0) {
      return `0 ${this.itemsPerPageLabel} ${length}`;
    }

    length = Math.max(length, 0);
    const startIndex = page * pageSize;
    const endIndex = startIndex < length ?
      Math.min(startIndex + pageSize, length) :
      startIndex + pageSize;

    return `${startIndex + 1} - ${endIndex} de ${length}`;
  };

  // Cambia el texto "Next page"
  nextPageLabel = 'Siguiente página';

  // Cambia el texto "Last page"
  lastPageLabel = 'Última página';

  // Cambia el texto "Previous page"
  previousPageLabel = 'Página anterior';

  // Cambia el texto "First page"
  firstPageLabel = 'Primera página';
}
